import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';




const Header = () => (
	<header>

		<nav>


{/* <Link activeClassName={style.active} href="/">Home</Link>  &nbsp;&nbsp; */}


</nav>


	</header>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js